var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudi({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Audi_Rings_Medium_wh-RGB",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 57.243,
    height: 19.145,
    viewBox: "0 0 57.243 19.145",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4",
    "data-name": "Trazado 4",
    d: "M0-100H57.243v19.145H0Z",
    transform: "translate(0 100)",
    fill: "#e7e7e7"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Audi_Rings_Medium_wh-RGB-2",
    "data-name": "Audi_Rings_Medium_wh-RGB",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3",
    "data-name": "Trazado 3",
    d: "M47.67-82.125a8.266,8.266,0,0,1-5.458-2.054,9.528,9.528,0,0,0,2.331-6.249,9.528,9.528,0,0,0-2.331-6.249,8.266,8.266,0,0,1,5.458-2.054,8.312,8.312,0,0,1,8.3,8.3,8.313,8.313,0,0,1-8.3,8.3M29.513-84.178a9.528,9.528,0,0,0,2.331-6.249,9.528,9.528,0,0,0-2.331-6.249,8.266,8.266,0,0,1,5.458-2.054,8.265,8.265,0,0,1,5.458,2.054A9.529,9.529,0,0,0,38.1-90.428a9.528,9.528,0,0,0,2.331,6.249,8.265,8.265,0,0,1-5.458,2.054,8.266,8.266,0,0,1-5.458-2.054m-12.7,0a9.527,9.527,0,0,0,2.331-6.249,9.528,9.528,0,0,0-2.331-6.249,8.265,8.265,0,0,1,5.458-2.054,8.266,8.266,0,0,1,5.458,2.054A9.528,9.528,0,0,0,25.4-90.428a9.527,9.527,0,0,0,2.331,6.249,8.266,8.266,0,0,1-5.458,2.054,8.265,8.265,0,0,1-5.458-2.054M1.269-90.428a8.312,8.312,0,0,1,8.3-8.3,8.265,8.265,0,0,1,5.458,2.054A9.529,9.529,0,0,0,12.7-90.428a9.528,9.528,0,0,0,2.331,6.249,8.265,8.265,0,0,1-5.458,2.054,8.313,8.313,0,0,1-8.3-8.3m14.653,5.342a8.264,8.264,0,0,1-1.954-5.342,8.264,8.264,0,0,1,1.954-5.342,8.265,8.265,0,0,1,1.953,5.342,8.265,8.265,0,0,1-1.953,5.342m12.7,0a8.265,8.265,0,0,1-1.954-5.342,8.265,8.265,0,0,1,1.954-5.342,8.265,8.265,0,0,1,1.954,5.342,8.265,8.265,0,0,1-1.954,5.342m12.7,0a8.265,8.265,0,0,1-1.953-5.342,8.265,8.265,0,0,1,1.953-5.342,8.265,8.265,0,0,1,1.954,5.342,8.265,8.265,0,0,1-1.954,5.342M47.67-100a9.532,9.532,0,0,0-6.35,2.418A9.531,9.531,0,0,0,34.971-100a9.532,9.532,0,0,0-6.35,2.418A9.532,9.532,0,0,0,22.272-100a9.531,9.531,0,0,0-6.35,2.418A9.532,9.532,0,0,0,9.572-100,9.583,9.583,0,0,0,0-90.428a9.583,9.583,0,0,0,9.572,9.572,9.532,9.532,0,0,0,6.35-2.418,9.531,9.531,0,0,0,6.35,2.418,9.532,9.532,0,0,0,6.35-2.418,9.532,9.532,0,0,0,6.35,2.418,9.531,9.531,0,0,0,6.35-2.418,9.532,9.532,0,0,0,6.35,2.418,9.583,9.583,0,0,0,9.572-9.572A9.583,9.583,0,0,0,47.67-100",
    transform: "translate(0 100)",
    fill: "#e7e7e7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudi);
export default __webpack_public_path__ + "static/media/audi.e25e3d83d123f7d9d15f6610856776c8.svg";
export { ForwardRef as ReactComponent };